var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement, useRef } from 'react';
import { mergeProps, useFocusRing } from 'react-aria';
import { useMergeRefs } from '../hooks';
import { iconStyle, innerContentStyle, linkStyle } from './styles';
import useIconSize from './use-icon-size';
function LinkInternal(_a, ref) {
    var { as, children, iconLeft, iconRight, inverted = false, size = 'inherit' } = _a, restProps = __rest(_a, ["as", "children", "iconLeft", "iconRight", "inverted", "size"]);
    const Element = as !== null && as !== void 0 ? as : 'a';
    const { focusProps, isFocusVisible } = useFocusRing();
    const linkRef = useRef(null);
    const iconSize = useIconSize(linkRef);
    const mergedRef = useMergeRefs(linkRef, ref);
    const typedRestProps = restProps;
    function renderIcon(originalIcon) {
        return originalIcon.props.size != null
            ? originalIcon
            : cloneElement(originalIcon, {
                css: [iconStyle, originalIcon.props.css],
                size: iconSize,
            });
    }
    return (_jsxs(Element, Object.assign({}, mergeProps(focusProps, typedRestProps), { css: linkStyle({
            inverted,
            isFocusVisible,
            size,
        }), ref: mergedRef }, { children: [iconLeft != null && renderIcon(iconLeft), _jsx("span", Object.assign({ css: innerContentStyle({
                    hasLeftIcon: !(iconLeft == null),
                    hasRightIcon: !(iconRight == null),
                    iconSize,
                }) }, { children: children })), iconRight != null && renderIcon(iconRight)] })));
}
export default LinkInternal;
